import React from 'react';
import Immutable from 'immutable';
import c from 'classnames';

import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
} from '../../../config/constants';

import {
  WysiwygField,
  ImageWithIllustration,
  FormattedLink,
} from '../../../components';

import ParagraphText from '../Text';

import './style.scss';

const ParagraphImage = ({ entity, className, withIndent }) => {
  const caption = entity.get('field_text');

  return (
    <div className={c('Paragraph', 'ParagraphImage', { 'u-indent': withIndent }, className)}>
      <div className={c('row')}>
        <div className={c('image', 'col-md-12')}>
          <ImageWithIllustration
            image={entity.getIn(['field_image', 0], Immutable.Map())}
            crops={Immutable.Map({
              [SCREEN_MOBILE]: 'cropped_standard_medium_viewport',
              [SCREEN_NORMAL]: 'crop_standard',
            })}
          />
          <div className="caption">
            <WysiwygField
              property="schema:text"
              html={caption.getIn([0, 'processed'])}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParagraphImage;
